import themeReducer from './themeReducer';

export * from './themeActions';
export default themeReducer;
